import React from 'react';
import PropTypes from 'prop-types';
import  { useDispatch, useSelector } from 'react-redux'
import { CompilaQuestionarioAzioni } from './CompilaQuestionarioAzioni.js';
// import { csvcSoggettiListV1 } from '../components-csvc-one/testSoggettiList.js';
import { useState }  from 'react';
// import {FalconComponentCard} from 'components/common/FalconComponentCard';
// import {FalconReactRange} from './FalconReactRange';
// import {FalconEditor} from 'components/common/FalconEditor';

import {CompilaQuestionarioRilevanza} from './CompilaQuestionarioRilevanza.js';
// import { BsInfoCircleFill } from "react-icons/bs";
import FalconCloseButton from 'components/common/FalconCloseButton';

import { Button, Row, Col, Modal } from 'react-bootstrap';
import Flex from 'components/common/Flex';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { Link } from 'react-router-dom';
// import { faHome } from '@fortawesome/free-solid-svg-icons';
// import { Range, getTrackBackground, FalconReactRange } from "../..index/index";
import { updateImpatto } from '../reduxStore/questCorrenteSlice.js'

function nomeEsteso(key) {
    const questionarioCorrente = useSelector((state) => state.questCorrente);
    // Estraggo Array stakeholders filtrato
    // const excludedIds = ['AZ', 'CT'];
    // const stakeholdersFiltered = questionarioCorrente.stakeholders.filter(stakeholder => !excludedIds.includes(stakeholder.id));
    const pair = questionarioCorrente.stakeholders.find(pair => pair.id === key);
    return pair ? pair.alias.toUpperCase() : null;
}

export const CompilaQuestionarioImpatti = (props) => {

    const questionarioCorrente = useSelector((state) => state.questCorrente);

    // --- START GESTIONE STATO MODAL ModalToRiskRedefine ---------------------------
    const [modalRiskRedefineShow, setModalRiskRedefineShow] = useState(false);
    const [impattoToRedefine, setImpattoToRedefine] = useState({impattoToRedefineKey:''});
    const dispatch = useDispatch();

    // const handleOpenModalToRiskRedefine = () =>  setModalRiskRedefineShow(true)
    const handleCloseModalToRiskRedefine = () => setModalRiskRedefineShow(false);
    const handleSubmitModalToRiskRedefine = () => {
        const updatedValues = {
            questionarioUuid: questionarioCorrente.questionarioUuid, 
            impattoToRemoveKey: impattoToRedefine.impattoToRedefineKey
        }
        if (
            updatedValues.questionarioUuid==='' | 
            updatedValues.impattoToRemoveKey==='' | 
            updatedValues.questionarioUuid==null | 
            updatedValues.impattoToRemoveKey==null
        ) {
            alert (`Si è verificata una situazione anomala. Riprova. (${JSON.stringify(updatedValues)}). Se il problema persiste contattare l'assistenza`)
        }
        dispatch(updateImpatto(updatedValues)) 
        setModalRiskRedefineShow(false)
    }    
    // --- END GESTIONE STATO MODAL ModalToRiskRedefine ---------------------------

    return (
        <>
        {props.impatti.map((impatto) => (<>
            <h5 className="text-primary mb-0"><span className="text-info fw-medium">Impatto {impatto.codiceCsvc} -</span> <strong>{impatto.tipo}</strong>: DA {nomeEsteso(impatto.soggettoImpattante)} A {(nomeEsteso(impatto.soggettoImpattato))}</h5><br />
            <Row className="g-0 align-items-center" style={{margin:"1%"}} >
                <Col sm="9">
                    <Flex alignItems="center">
                    <h5 className="text-primary mb-0"><span className="text-info fw-medium">Rischio:</span>&nbsp;&nbsp;&nbsp; <strong>{impatto.descrizione}</strong></h5>
                    </Flex>
                </Col>
                <Col md="auto" className="mb-2 mb-md-0">
                    <Button variant={'primary'}  onClick={()=>{
                            setImpattoToRedefine({impattoToRedefineKey:impatto.key} )
                            setModalRiskRedefineShow(true)
                        }}>
                        Ridefinisci il rischio
                    </Button>                
                </Col>
            </Row>

            <CompilaQuestionarioRilevanza impatto={impatto.key} eriRowsObjectArray= {impatto.eriRowsObjectArray}/>
            <CompilaQuestionarioAzioni azioni={impatto.azioni} />

            <Modal size="lg" show={modalRiskRedefineShow} onHide={handleCloseModalToRiskRedefine} backdrop="static" keyboard={false}>
                <Modal.Header>
                <Modal.Title>Ridefinisci il rischio</Modal.Title>
                <FalconCloseButton onClick={handleCloseModalToRiskRedefine}/>
                </Modal.Header>
                <Modal.Body>
                <div>
                    <p>Per ridefinire un rischio, il primo passaggio consiste nell'eliminare l'attuale rischio <strong><span style={{color: 'red'}} >({impatto.descrizione})</span></strong> presente nel questionario.<br />
                    L'eliminazione del rischio presente comporterà anche l'eliminazione di tutti i dati correlati, compresi gli esempi.</p>
                </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModalToRiskRedefine}>
                        Annulla
                    </Button>
                    <Button variant="danger"  onClick={()=>{
                            setImpattoToRedefine({impattoToRedefineKey:impatto.key} )
                            handleSubmitModalToRiskRedefine()
                        }}>
                        CONFERMA L'ELIMINAZIONE DEL RISCHIO
                    </Button>
                </Modal.Footer>
            </Modal>
        </>))}
        </>
    );
};

CompilaQuestionarioImpatti.propTypes = {
    impatti: PropTypes.array.isRequired
};

